export default __webpack_public_path__ + "static/media/operandio.857111ac.svg";